export const CATEGORY_INIT_ACTION = "CATEGORY_INIT_ACTION";
export const CATEGORY_SUCCESS_ACTION = CATEGORY_INIT_ACTION + "_SUCCESS";
export const CATEGORY_FAIL_ACTION = CATEGORY_INIT_ACTION + "_ERROR";

export const FETCH_CATEGORY_INIT_ACTION = "CATEGORY_INIT_ACTION";
export const FETCH_CATEGORY_SUCCESS_ACTION = CATEGORY_INIT_ACTION + "_SUCCESS";
export const FETCH_CATEGORY_FAIL_ACTION = CATEGORY_INIT_ACTION + "_ERROR";

export const FETCH_CATEGORY_BYID_INIT_ACTION = "FETCH_CATEGORY_BYID_INIT_ACTION";
export const FETCH_CATEGORY_BYID_SUCCESS_ACTION = FETCH_CATEGORY_BYID_INIT_ACTION + "_SUCCESS"
export const FETCH_CATEGORY_BYID_FAIL_ACTION = FETCH_CATEGORY_BYID_INIT_ACTION + "_ERROR"

export function AddCatgrs(value) {
    return {
        type: CATEGORY_INIT_ACTION,
        value: value
    }
}
export function fetchCatgrys() {
    return {
        type: FETCH_CATEGORY_INIT_ACTION
    }
}

export function fetchCatgryById(item) {
    return {
        type: FETCH_CATEGORY_BYID_INIT_ACTION,
        item: item
    }
}